module.exports = __webpack_public_path__ + "static/media/ripley-communication-slide-1.aab6c006.jpg";